import { createListViewContainer } from 'factories/ListView'
import listActions from 'actions/lists'
import listItemActions from 'actions/lists/listItems'
import orderItemActions from 'actions/orders/orderItems'
import { getStorageItem, updateStorageItem } from 'helpers/localStorage'
import { wrapItems } from 'helpers/utils'
import Component from 'components/Orders/AddItems/AddFromList'

export default createListViewContainer({
  extraDispatchToProps: (dispatch, props) => ({
    getItems: (params = {}) => {
      const listId = getStorageItem('orders.addItems.addFromList', {}).filterDto?.listId

      if (listId) {
        return dispatch(
          listItemActions.getChildItems(listId, {
            domainObjectType: 'Order',
            listItemMode: 'ProductListProcurementRecord',
            listType: 'Product',
            ...params,
          })
        )
      }

      return dispatch(listActions.getItems({ type: 'Product' })).then((r) => {
        const list = r.value.data.items[0]

        if (list) {
          updateStorageItem('orders.addItems.addFromList', {}, (draft) => {
            draft.filterDto.listId = list.id
            draft.filterDto.listName = list.name
          })

          return dispatch(
            listItemActions.getChildItems(list.id, {
              domainObjectType: 'Order',
              listItemMode: 'ProductListProcurementRecord',
              listType: 'Product',
              ...params,
            })
          )
        }

        return wrapItems([])
      })
    },
    populateOrderItems: (params) => dispatch(orderItemActions.populateOrderItems(params)),
  }),
})(Component)
